<template>
  <v-container>
    <v-overlay absolute :value="loading"
      ><v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col xs="12">
        <v-card class="mx-auto" color="#ffc400 " dark max-width="500">
          <v-card-title>
            <v-row>
              <v-col cols="11">
                <v-menu
                  v-if="!loading"
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  max-width="320px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateFormat"
                      label="Seleccione mes"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    type="month"
                    scrollable
                    locale="es-419"
                    @change="datePick"
                    :max="maxDate"
                    @click="$refs.menu.save(date)"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
          </v-card-title>

          <v-card-text class="headline font-weight-bold">
            <template v-if="totalConversations > 0">
              <ChartPie :whatsapp="whatsapp" :widget="widget" />
            </template>
          </v-card-text>

          <v-card-actions>
            <v-list-item class="grow">
              <v-list-item-content>
                <v-list-item-title>{{
                  month.charAt(0).toUpperCase() + month.slice(1)
                }}</v-list-item-title>
              </v-list-item-content>
              <v-row align="center" justify="end">
                <v-icon class="mr-1"> mdi-chart-pie </v-icon>
                <span class="subheading">{{ totalConversations }}</span>
              </v-row>
            </v-list-item>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col xs="12">
        <v-card class="mx-auto" max-width="600">
          <v-card-text>
            <div>Detalle</div>
            <v-simple-table class="text-center">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center">Canal</th>
                    <th class="text-center">Conversariones</th>
                    <th class="text-center">Mensajes</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Whatsapp</td>
                    <td>{{ whatsapp.total }}</td>
                    <td>{{ whatsapp.totalMessages }}</td>
                  </tr>
                  <tr>
                    <td>Widget</td>
                    <td>{{ widget.total }}</td>
                    <td>{{ widget.totalMessages }}</td>
                  </tr>
                  <tr>
                    <td class="text-right font-weight-bold">Total</td>
                    <td class="font-weight-bold">
                      {{ totalConversations }}
                    </td>
                    <td class="font-weight-bold">
                      {{ totalMessages }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-card-actions> </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <!-- <v-row dense>
      <v-col cols="12">
        <v-card color="#385F73" dark>
          <v-card-title class="headline"> Convesaciones por día </v-card-title>
          <v-card-text>
            <template v-if="totalConversations > 0">
              <ChartLine
                :whatsapp="whatsapp"
                :widget="widget"
                :totalDays="totalDays"
              />
            </template>
          </v-card-text>
          <v-card-actions>
            <v-list-item class="grow">
              <v-list-item-content>
                <v-list-item-title>{{
                  month.charAt(0).toUpperCase() + month.slice(1)
                }}</v-list-item-title>
              </v-list-item-content>
              <v-row align="center" justify="end">
                <v-icon class="mr-1"> mdi-chart-pie </v-icon>
                <span class="subheading">{{ totalConversations }}</span>
              </v-row>
            </v-list-item>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row> -->
    <v-row dense>
      <v-col cols="12">
        <v-card color="#385F73" height="35%<s">
          <v-card-title class="headline white--text">
            Convesaciones por día
          </v-card-title>
          <v-card-text>
            <template v-if="totalConversations > 0">
              <div class="linear-chart-cont">
                <LineChartB
                  :whatsapp="whatsapp"
                  :widget="widget"
                  :totalDays="totalDays"
                  :isDatePickerChanged="isDatePickerChanged"
                 />
              </div>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-list-item class="grow">
              <v-list-item-content>
                <v-list-item-title class="white--text">{{
                  month.charAt(0).toUpperCase() + month.slice(1)
                }}</v-list-item-title>
              </v-list-item-content>
              <v-row align="center" justify="end">
                <v-icon class="mr-1 white--text"> mdi-chart-pie </v-icon>
                <span class="subheading white--text">{{ totalConversations }}</span>
              </v-row>
            </v-list-item>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar v-model="alertSnackbar" :timeout="3000" top>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="alertSnackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
// @ is an alias to /src
import ChartPie from "../components/charts/ChartPie";
import LineChartB from "../components/charts/LineChartB.vue";
import { Config } from "../config";

export default {
  name: "Home",
  components: {
    ChartPie,
    LineChartB
  },
  data: () => ({
    snackbarText: "",
    alertSnackbar: false,
    date: new Date().toISOString().substr(0, 7),
    endDate: new Date().toISOString().substr(0, 7),
    dateFormat: "",
    month: "",
    maxDate: new Date().toISOString().substr(0, 7),
    menu: false,
    modal: false,
    whatsapp: "",
    whatsappObj: {
      total: 0,
      sessions: [],
      byDay: [],
      totalMessages: 0,
    },
    widgetObj: {},
    widget: "",
    loading: true,
    totalConversations: 0,
    totalMessages: 0,
    totalDays: 0,
    isDatePickerChanged: false,
  }),
  mounted() {
    this.datePick();
  },
  beforeUpdate() {
    this.isDatePickerChanged = !this.isDatePickerChanged
  },
  computed: {},
  methods: {
    totalConversationByDays(channel) {
      let byDays = [];
      for (let index = 1; index <= this.totalDays; index++) {
        let day = ("0" + index).substr(-2);
        byDays[index - 1] = 0;
        channel.sessions.forEach((session) => {
          if (this.$moment(session.startDatetime * 1000).format("DD") == day) {
            byDays[index - 1]++;
          }
        });
      }
      return byDays;
    },
    getDataByMoth() {
      this.loading = true;
      this.whatsapp = {};
      this.widget = {};
      let startDate = this.$moment(`${this.date}-01 00:00`).format("X");
      let endDate = this.$moment(
        this.$moment(this.date).format("YYYY-MM-") +
          this.$moment(this.date, "YYYY-MM").daysInMonth() +
          " 23:59:59"
      ).format("X");
      let url = Config.url + '/db/conversations/';
      // Test url
      // let url =
      //   Config.url +
      //   `/db/conversations/startDate=${startDate}&/endDate=${endDate}`;
      let params = {
        startDate: startDate,
        endDate: endDate
      };
      this.axios
        // Test .get() 
        // .get(url) 
        .get(url, { params: params })
        .then((res) => {
          this.widget.total = 0;
          this.whatsapp.total = 0;
          this.widget.totalMessages = 0;
          this.whatsapp.totalMessages = 0;
          this.widget.sessions = [];
          this.whatsapp.sessions = [];
          this.calculateTotalConversations(res.data);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.snackbarText = "Error en servidor, intente mas tarde";
          this.alertSnackbar = err;
          this.loading = false;
        });
    },
    calculateTotalConversations(resConversations) {
      this.totalConversations = resConversations.totalConversations;
      const conversations = resConversations.conversations;
      conversations.forEach((conv) => {
        // this.totalMessages += conv.conversation;
        if (conv.channel == "WHATSAPP") {
          this.whatsapp.total++;
          this.whatsapp.totalMessages += conv.conversation_count;
          console.log('Whatsapp total: ', this.whatsappObj.total);
          console.log('Single Conversation: ', conv.conversation);
          console.log('Whatsapp totalMessages: ', this.whatsappObj.totalMessages);
          this.whatsapp.sessions.push(conv);
        }
        if (conv.channel == "WIDGET") {
          this.widget.total++;
          this.widget.totalMessages += conv.conversation;
          this.widget.sessions.push(conv);
        }
      });
      this.totalMessages = this.whatsapp.totalMessages + this.widget.totalMessages;
      this.totalDays = this.$moment(this.date).daysInMonth();
      this.whatsapp.byDay = this.totalConversationByDays(this.whatsapp);
      this.widget.byDay = this.totalConversationByDays(this.widget);
    },
    labels() {
      let labels = [];
      for (let index = 1; index <= this.totalDays; index++) {
        labels.push(` -${index}- `);
      }
      return labels;
    },
    datePick() {
      this.menu = false;
      this.dateFormat = this.$moment(this.date).format("MM-YYYY");
      this.month = this.$moment(this.date).format("MMMM");
      this.getDataByMoth();
    },
  },
};
</script>
<style scoped>
.linear-chart-cont {
  width: 100% !important;
  max-height: 25% !important;
}
</style>
